import {
  IonButton,
  IonButtons,
  IonCol,
  IonRow,
  IonInput,
  useIonToast,
  IonIcon,
} from "@ionic/react";
import { getStorage, ref as storageRef, uploadBytes } from "firebase/storage";
import { auth } from "../utils/db";
import { useRef, useState } from "react";
import { cloudUpload } from "ionicons/icons";

export default function SaveDoc({ username, onUpload }) {
  const fileInputRef = useRef(null);
  const [presentToast] = useIonToast();
  const [selectedFile, setSelectedFile] = useState(null);
  const [characterName, setCharacterName] = useState("");

  const MAX_FILE_SIZE = 20 * 1024 * 1024; // 20 MB em bytes

  const handleButtonClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const allowedTypes = ["application/pdf", "image/jpeg", "image/png"];
    if (!allowedTypes.includes(file.type)) {
      presentToast({
        message: "Apenas arquivos de imagem ou PDFs são permitidos!",
        duration: 3000,
        translucent: true,
      });
      return;
    }

    if (file.size > MAX_FILE_SIZE) {
      presentToast({
        message: "O arquivo é muito grande! Máximo: 20 MB",
        duration: 3000,
        translucent: true,
      });
      return;
    }

    setSelectedFile(file); // salva o arquivo para o próximo passo
  };

  const handleUpload = async () => {
    if (!selectedFile) return;
    if (!characterName.trim()) {
      presentToast({
        message: "Por favor, digite o nome do personagem!",
        duration: 3000,
        translucent: true,
      });
      return;
    }

    try {
      const user = auth.currentUser;
      if (!user) throw new Error("Usuário não está logado");

      const storage = getStorage();
      const fileRef = storageRef(
        storage,
        `uploads/${user.uid}/${username}_${characterName}`
      );

      // Upload do arquivo
      await uploadBytes(fileRef, selectedFile);

      presentToast({
        message: `Arquivo enviado com sucesso!`,
        duration: 2000,
        translucent: true,
      });

      // resetar estado
      setSelectedFile(null);
      setCharacterName("");

      if (onUpload) onUpload();
    } catch (err) {
      presentToast({
        message: `Erro ao enviar: ${err.message}`,
        duration: 3000,
        translucent: true,
      });
      console.error(err);
    }
  };

  return (
    <IonRow>
      <IonCol>
        <IonButtons>
          {!selectedFile && (
            <IonButton color="tertiary" onClick={handleButtonClick}>
              Subir Ficha
              <IonIcon style={{ marginLeft: 4 }} icon={cloudUpload} />
            </IonButton>
          )}
          <input
            type="file"
            accept=".jpg, .jpeg, .png, .pdf"
            ref={fileInputRef}
            style={{ display: "none" }}
            onChange={handleFileChange}
          />
        </IonButtons>

        {selectedFile && (
          <div style={{ marginTop: 10 }}>
            <IonInput
              placeholder="Nome do Personagem"
              value={characterName}
              onChange={(e) => setCharacterName(e.target.value)}
            />
            <IonButton
              style={{ marginTop: 5 }}
              color="tertiary"
              onClick={() => {
                handleUpload();
                fileInputRef.current.value = "";
              }}
            >
              Subir Ficha
            </IonButton>
            <IonButton
              color="medium"
              onClick={() => {
                setSelectedFile(null);
                setCharacterName("");
              }}
            >
              Cancelar
            </IonButton>
          </div>
        )}
      </IonCol>
    </IonRow>
  );
}
